// Build the `/profile?u=<email>` URL for navigating to another user's
// profile page. Coerces `undefined`/`null` to '' so callers don't have
// to guard the input — `encodeURIComponent('')` yields ''.
// Use via `el.call('profilePath', email)` to keep the encoding choice
// (encodeURIComponent vs raw) in one place; if profile URLs switch
// to a different shape (e.g. /users/:slug), every consumer follows.
export const profilePath = (email) => `/profile?u=${encodeURIComponent(email || '')}`
